/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayHeight: NonNullable<unknown> }} Input_Position_Y_Dialog_TextInputs */



/**
* | output |
* | --- |
* | "Enter a value between 1 and {displayHeight}:" |
*
* @param {Input_Position_Y_Dialog_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_dialog_text = /** @type {((inputs: Input_Position_Y_Dialog_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_Dialog_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Entrez une valeur entre 1 et ${i?.displayHeight} :`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Geben Sie einen Wert zwischen 1 und ${i?.displayHeight} ein:`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Inserisci un valore compreso tra 1 e ${i?.displayHeight}:`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Введите значение от 1 до ${i?.displayHeight}:`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Introduzca un valor entre 1 y ${i?.displayHeight}:`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`请输入介于 1 和 ${i?.displayHeight} 之间的值：`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`1 から ${i?.displayHeight} までの値を入力してください:`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`1 और ${i?.displayHeight} के बीच कोई मान दर्ज करें:`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Insira um valor entre 1 e ${i?.displayHeight}:`)
	return /** @type {LocalizedString} */ (`Enter a value between 1 and ${i?.displayHeight}:`)
});